import { BootstrapBrowserBuilder } from '@zg-rentals/rp-bootstrap-browser';
import { analytics } from './analytics';

const builder = new BootstrapBrowserBuilder('applications-renter-web', Number(process.env.NEXT_PUBLIC_BUILD_NUMBER))
  .withHostedAppLoggerOptions('rental-manager-api', process.env.NEXT_PUBLIC_LOG_LEVEL)
  .withOnRegister(analytics.initialize);

export const bootstrap = builder.build();
